import { GroupId } from '../typings/groups';
import { EditGroupSessionValue } from '../typings/groupsEditState';

import { Session } from './Session/Session';
import { StorageKeyType } from './Storage/Storage';

export class GroupIdsForGroupsEditHelpers {
    public static getCampAndGroupIds(login: string): EditGroupSessionValue {
        const { editGroups } = Session.getValueFromCurrentSession(login);

        if (!editGroups) {
            return {
                groupsIds: [],
                campaignsIds: [],
                isNew: false,
                isNewEmptyGroup: false
            };
        }

        return editGroups;
    }

    public static setCampAndGroupIds(
        login: string,
        groupsIds: Array<GroupId>,
        campaignIds: Array<string>,
        isNew: boolean = false,
        isNewEmptyGroup: boolean = false
    ): void {
        const currentSession = Session.getValueFromCurrentSession(login);

        Session.setValueToCurrentSession(login, {
            ...currentSession,
            [StorageKeyType.editGroups]: {
                groupsIds: groupsIds,
                campaignsIds: campaignIds,
                isNew,
                isNewEmptyGroup
            }
        });
    }
}
